export function scrubSecretSantaUrls(properties: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(properties)) {
    result[key] = typeof value === 'string' ? value.replace(/\/s\/[^/?#\s]+/, '/s/[id]') : value;
  }
  return result;
}
